import { render, staticRenderFns } from "./DefaultContent-Categories.vue?vue&type=template&id=f5f73386&"
import script from "./DefaultContent-Categories.vue?vue&type=script&lang=js&"
export * from "./DefaultContent-Categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports